<template>
  <form-group :name="validateName" :attribute="`fields.${validateName}`">
    <template slot-scope="{ attrs }">
      <v-text-field
        v-bind="attrs"
        outlined
        :type="feildType ? feildType : 'text'"
        v-model="getModelValue"
        autocomplete
        @keyup="active"
      ></v-text-field>
    </template>
  </form-group>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    feildType: {
      default: String
    },
    validateName: {
      required: true,
      type: String
    },
    v: {
      type: Object
    }
  },
  computed: {
    getModelValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.v) {
          this.v.$touch();
        }
        this.$emit("input", value);
      }
    }
  },
  methods: {
    active() {
      this.$emit("activeSaveButton");
    }
  }
};
</script>
